const LOGOUT_FLAG_KEY = "__ael_dealer_logout_in_progress_at";
const LOGOUT_FLAG_TTL_MS = 20 * 1000;
const logoutSubscribers = new Set();
let storageListenerAttached = false;

const notifyLogoutSubscribers = () => {
  logoutSubscribers.forEach((subscriber) => {
    try {
      subscriber();
    } catch {}
  });
};

const ensureStorageListener = () => {
  if (typeof window === "undefined" || storageListenerAttached) return;

  window.addEventListener("storage", (event) => {
    if (event.key === LOGOUT_FLAG_KEY && event.newValue) {
      notifyLogoutSubscribers();
    }
  });
  storageListenerAttached = true;
};

const clearStoredLogoutFlag = () => {
  if (typeof window === "undefined") return;

  try {
    window.__AEL_DEALER_LOGOUT_IN_PROGRESS_AT = 0;
    window.sessionStorage?.removeItem(LOGOUT_FLAG_KEY);
    window.localStorage?.removeItem(LOGOUT_FLAG_KEY);
  } catch {}
};

export const markDealerLogoutInProgress = () => {
  if (typeof window === "undefined") return;

  const timestamp = String(Date.now());
  try {
    window.__AEL_DEALER_LOGOUT_IN_PROGRESS_AT = Number(timestamp);
    window.sessionStorage?.setItem(LOGOUT_FLAG_KEY, timestamp);
    window.localStorage?.setItem(LOGOUT_FLAG_KEY, timestamp);
  } catch {}

  notifyLogoutSubscribers();
};

export const clearDealerLogoutInProgress = () => {
  clearStoredLogoutFlag();
};

export const isDealerLogoutInProgress = () => {
  if (typeof window === "undefined") return false;

  const readTimestamp = (value) => {
    const timestamp = Number(value);
    return Number.isFinite(timestamp) && timestamp > 0 ? timestamp : null;
  };

  const readStorageTimestamp = (storage) => {
    try {
      return readTimestamp(storage?.getItem(LOGOUT_FLAG_KEY));
    } catch {
      return null;
    }
  };

  const timestamps = [
    readTimestamp(window.__AEL_DEALER_LOGOUT_IN_PROGRESS_AT),
    readStorageTimestamp(window.sessionStorage),
    readStorageTimestamp(window.localStorage),
  ].filter(Boolean);
  if (!timestamps.length) return false;

  const timestamp = Math.max(...timestamps);
  if (Date.now() - timestamp < LOGOUT_FLAG_TTL_MS) return true;

  clearStoredLogoutFlag();
  return false;
};

export const subscribeToDealerLogout = (subscriber) => {
  if (typeof subscriber !== "function") return () => {};

  ensureStorageListener();
  logoutSubscribers.add(subscriber);
  return () => logoutSubscribers.delete(subscriber);
};
